module.exports = __webpack_public_path__ + "static/media/arrow-full-light.332f8a72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-full-light.svg
// module id = 180
// module chunks = 0